/** Stored action types that share the unified Forward Call UI. */
export const FORWARD_FAMILY_ACTIONS = Object.freeze([
  "forward",
  "forwardvwm",
  "dynamic_forward",
]);

export const FORWARD_MODE_SIMPLE = "simple";
export const FORWARD_MODE_DYNAMIC = "dynamic";

export function isForwardFamilyAction(type) {
  return FORWARD_FAMILY_ACTIONS.includes(type);
}

/**
 * Map a stored action type to the UI mode selector.
 * @returns {"simple"|"dynamic"|null}
 */
export function getForwardMode(type) {
  if (type === "dynamic_forward") return FORWARD_MODE_DYNAMIC;
  if (type === "forward" || type === "forwardvwm") return FORWARD_MODE_SIMPLE;
  return null;
}

/**
 * Whether Twilanswer voicemail fallback is on for the current stored type.
 * Simple: implied by forwardvwm. Dynamic: uses twilanswerVmFallback flag.
 */
export function getForwardVmFallback(type, twilanswerVmFallback) {
  if (type === "forwardvwm") return true;
  if (type === "forward") return false;
  if (type === "dynamic_forward") return twilanswerVmFallback === true;
  return false;
}

/**
 * Resolve UI mode + VM toggle into the stored action type.
 * For Dynamic, vmFallback does not change the type (stored as twilanswerVmFallback).
 */
export function resolveForwardAction({ mode, vmFallback }) {
  if (mode === FORWARD_MODE_DYNAMIC) return "dynamic_forward";
  return vmFallback ? "forwardvwm" : "forward";
}

/**
 * Whether the Recording field should be shown for the current forward state.
 */
export function shouldShowForwardRecording({ mode, numberValue, vmFallback }) {
  if (mode === FORWARD_MODE_SIMPLE) return !!vmFallback;
  const backupIsNone = !numberValue || numberValue === "none";
  return backupIsNone || !!vmFallback;
}
